<template>
  <div>
    <!-- Page Title Area -->
    <div class="page-title-area">
      <div class="container">
        <h2>{{ title }}</h2>
      </div>
    </div>

    <!-- Product Content Area -->
    <section class="ptb-80">
      <div class="container">
        <div v-if="loading" class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else-if="error" class="alert alert-danger" role="alert">
          {{ error }}
        </div>
        <div v-else class="row">
          <div class="col-lg-8">
            <div class="product-content" v-html="content"></div>
          </div>
          <div class="col-lg-4" v-if="product">
            <div class="product-sidebar">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">{{ product.Title }}</h4>
                  <p class="card-text" v-if="product.Description">{{ product.Description }}</p>
                  
                  <div v-if="product.Price" class="price-box mt-4">
                    <h5>Price</h5>
                    <div class="price">{{ formatPrice(product.Price) }}</div>
                  </div>
                  
                  <a v-if="product.CtaUrl" :href="product.CtaUrl" class="btn btn-primary btn-block mt-4">
                    {{ product.CtaText || 'Get Started' }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { fetchCmsContent } from '../utils/api'

export default {
  name: 'ProductView',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const route = useRoute()
    const title = ref('')
    const content = ref('')
    const product = ref(null)
    const loading = ref(true)
    const error = ref(null)

    const formatPrice = (price) => {
      if (!price) return ''
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(price)
    }

    const fetchProduct = async (slug) => {
      loading.value = true
      error.value = null
      
      try {
        const response = await fetchCmsContent('product', slug)
        if (response && response.Title) {
          title.value = response.Title
          content.value = response.Html || response.Content || ''
          product.value = response
          document.title = `${response.Title} - AtOnline.com`
        } else {
          error.value = 'Product not found'
        }
      } catch (err) {
        console.error('Error fetching product:', err)
        error.value = 'Error loading product content'
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      fetchProduct(props.slug)
    })

    // Watch for route changes
    watch(() => route.params.slug, (newSlug) => {
      if (newSlug && newSlug !== props.slug) {
        fetchProduct(newSlug)
      }
    })

    return {
      title,
      content,
      product,
      loading,
      error,
      formatPrice
    }
  }
}
</script>

<style scoped>
.product-content {
  min-height: 300px;
}

.price-box {
  background: #f7fafd;
  padding: 15px;
  border-radius: 5px;
}

.price {
  font-size: 24px;
  font-weight: 600;
  color: #44ce6f;
}
</style>